import React from 'react';
import { PeekTooltip, PeekContainedIconButton, PeekTypography } from '@piiqtechnologies/ui-components';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import { HotspotType } from '../../../../types/Space.js';
import '../../../../types/Tour.js';
import Linkify from 'linkify-react';
import { HotspotIcon } from './HotspotIcon.js';

const InfoHotspot = ({ _id, text, helpers, sceneId, relatedContext }) => {
    const onTooltipOpen = () => {
        var _a;
        helpers.clickEventAnalytics("Infospot", {
            roomId: sceneId,
            roomName: (_a = relatedContext === null || relatedContext === void 0 ? void 0 : relatedContext.node) === null || _a === void 0 ? void 0 : _a.label,
            hotspotId: _id,
            hotspotName: text,
        });
    };
    return (React.createElement(PeekTooltip, { PopperProps: {
            disablePortal: true,
        }, sx: {
            width: "200px",
            "& .MuiTooltip-tooltip": {
                width: "100%",
                boxShadow: "none",
                whiteSpace: "normal",
            },
        }, enterTouchDelay: 0, leaveTouchDelay: 3000, onOpen: onTooltipOpen, placement: "top", title: React.createElement(Linkify, { options: {
                attributes: {
                    onClick: (event) => {
                        window.open(event.target.href, "_blank");
                    },
                },
            } }, text) },
        React.createElement(PeekContainedIconButton, { id: "info-button", sx: { backgroundColor: "secondary.main", ":hover": { backgroundColor: "secondary.main" } }, "aria-label": "info hotspot" },
            React.createElement(PeekTypography, { color: "text.secondary", fontSize: 22 },
                React.createElement(HotspotIcon, { type: HotspotType.Info })))));
};

export { InfoHotspot, InfoHotspot as default };
